var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.currentCustomer = "{{ customer }}"



Shopify.login = function() {
  const path = location.pathname
  
  location.href = domains.cms_url + '/user/login?destination=' + domains.shop_url + path
}

Shopify.register = function() {
  const path = location.pathname
  
  location.href = domains.cms_url + '/user/register?destination=' + domains.shop_url + path
}

Shopify.logout = async function() {
	// await clearCart()
  const logoutUrl = domains.cms_url + '/user/logout?' + 'location=' + window.location
  location.href = logoutUrl
}

async function clearCart() {
  fetch('/cart/clear.js', { method: 'POST' })
}

if (location.pathname === '/account/login') {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const returnTo = urlParams.get('return_to') || '';
    let cmsUrl = location.href.includes('test-shop') ? domains.cms_url_staging : domains.cms_url
    let shopUrl = location.href.includes('test-shop') ? domains.shop_url_staging : domains.shop_url
    let apiUrl = 'https://api.green.gohunt.com/uapi/shopify/user/refresh?destination=' + shopUrl + returnTo;
    fetch(apiUrl,
      {
        method:'GET',
        credentials:'include',
      }).then(response => {
          if (response.status === 401) {
           location.replace(cmsUrl + '/user/login?destination=' + shopUrl + returnTo)
          }
          return response.json(); 
        }).then(data=>{
          if(data.success==true){
            location.replace(data.result)
            }
        }).catch(error=>console.error('Error:', error));
}


function request(method, url, options = {}, data = {}, successCallBack = function(res) {}, failCallBack = function(err) {}) {
  try {
     const xhr = new XMLHttpRequest()
	 let responseType = 'json'
     xhr.open(method, url)

     if (options && options.responseType) {
       responseType = options.responseType
     }
    
     xhr.responseType = responseType

     if (!options && !options.headers) {
       options.headers['Content-Type'] = 'application/json'
     }
    
    if (options && options.withCredentials) {
      xhr.withCredentials = true
    }
    

     if (options && options.headers) {
       for (let key in options.headers) {
         xhr.setRequestHeader(key, options.headers[key])
       }
     }

     xhr.onload = function() {
       if (xhr.status >= 400) {
         failCallBack(xhr.response)
       } else {
         successCallBack(xhr.response)
       }
     }

     xhr.onerror = function() {
       failCallBack(new Error('Something went wrong.'))
     }
     
     const res = xhr.send(JSON.stringify(data))
  } catch(error) {
  	throw error
  }
  

}

class AjaxRequest {
  constructor(options) {
    this.options = options || {}
    this.successCallback = function(res) { }
    this.failCallback = function(err) { }
  } 
    
  GET(url, successCB = this.successCallback, failCB = this.failCallback) {
    return request('GET', url, this.options, {}, successCB, failCB)
  }
  
  POST(url, body, successCB = this.successCallback, failCB = this.failCallback) {
  	return request('POST', url, this.options, body, successCB, failCB)
  }
  
  PATCH(url, body, successCB = this.successCallback, failCB = this.failCallback) {
  	return request('PATCH', url, this.options, body, successCB, failCB)
  }
  
  PUT(url, body, successCB = this.successCallback, failCB = this.failCallback) {
  	return request('PUT', url, this.options, body, successCB, failCB)
  }
  
  DELETE(url, body, successCB = this.successCallback, failCB = this.failCallback) {
  	return request('DELETE', url, this.options, body, successCB, failCB)
  }
  
  
}

function getCookies() {
  const cookies = document.cookie.split(';')
  const cookieObject = cookies
    .map(function(cookie) {
      return cookie.trim().split('=').map(decodeURIComponent)   
    })
    .reduce(function(obj, cookieArray) {
      try {
        obj[cookieArray[0]] = JSON.parse(cookieArray[1])
      } catch(error) {
        obj[cookieArray[0]] = cookieArray[1]
      }

      return obj
    }, {})
  
  return cookieObject
}

function eraseCookie(name, path, domain) {
  document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function showCartDrawer() {
  if (location.pathname !== '/cart') {
    const cartDrawerOverlay = document.querySelector('.cart-popout-overlay')
    const cartDrawerElement = document.querySelector('.cart-modal')
    cartDrawerOverlay.style.pointerEvents = 'auto'
    cartDrawerOverlay.style.opacity   = 1
    cartDrawerElement.style.transform = 'translateX(0)'
    // cartDrawerOverlay.style.display = 'block'
    cartDrawerElement.style.display = 'flex'
    cartDrawerElement.style.flexDirection = 'column'
    
  }
}

function closeCartModal(event) {
  const overlayElement  = document.querySelector('.cart-popout-overlay')
  const cartModal       = document.querySelector('.cart-modal')
  
  overlayElement.style.opacity = 0
  overlayElement.style.pointerEvents = 'none'
  cartModal.style.transform = 'translateX(100%)'
  // overlayElement.style.display = 'none'
  // cartModal.style.display      = 'none'
  cartModal.classList.remove('active')
}

let appLauncherMenuOpen = false;

function showAppLauncher() {
  const mad = document.querySelector('.menu-app--dropdown')
  mad.classList.add("active");
  document.querySelector('.menu-app-btn.menu-close').classList.add("show");
  document.querySelector('.menu-app-btn.menu-open').classList.remove("show");
  appLauncherMenuOpen = !appLauncherMenuOpen;
}

function hideAppLauncher() {
  document.querySelector('.menu-app--dropdown').classList.remove("active");
  document.querySelector('.menu-app-btn.menu-close').classList.remove("show");
  document.querySelector('.menu-app-btn.menu-open').classList.add("show");
  appLauncherMenuOpen = !appLauncherMenuOpen;
}


document.getElementById('sushiMenuOpen').addEventListener('keypress', function(event) {
  if (appLauncherMenuOpen == false) {
        if (event.keyCode == 13) { showAppLauncher() };
  } else {
        if (event.keyCode == 13) { hideAppLauncher() };
  }

});


function showdropheader() {
  document.querySelector('.accountDropdown').classList.add("active");
  document.querySelector('.hide-dh').classList.add("show");
  document.querySelector('.show-dh').classList.remove("show");
}
function hidedropheader() {
  document.querySelector('.accountDropdown').classList.remove("active");
  document.querySelector('.hide-dh').classList.remove("show");
  document.querySelector('.show-dh').classList.add("show");
}

document.getElementById('accountMenuOpen').addEventListener('keypress', function(event) {
  if (event.keyCode == 13) { showdropheader() }  
});

document.getElementById('accountMenuClose').addEventListener('keypress', function(event) {
  if (event.keyCode == 13) { hidedropheader() } 
});



var registrationExists = document.getElementById('accountDropdownRegister');
var logInButtonExists = document.getElementById('accountDropdownLogIn');
var logOutButtonExists = document.getElementById('accountDropdownLogOut');


if (registrationExists == true) {
    document.getElementById('accountDropdownRegister').addEventListener('keypress', function(event) {
       if (event.keyCode == 13) { Shopify.register() } 
    });
}

if (logInButtonExists == true) {
    document.getElementById('accountDropdownLogIn').addEventListener('keypress', function(event) {
       if (event.keyCode == 13) { Shopify.login() } 
    });
}

if (logOutButtonExists == true) {
    document.getElementById('accountDropdownLogOut').addEventListener('keypress', function(event) {
       if (event.keyCode == 13) { Shopify.logout() } 
    });
}




document.addEventListener('mouseup', function(e) {
  var container = document.querySelector('.menu-app--dropdown');
  if (!container.contains(e.target)) {
    document.querySelector('.menu-app--dropdown').classList.remove("active");
    document.querySelector('.menu-app-btn.menu-close').classList.remove("show");
    document.querySelector('.menu-app-btn.menu-open').classList.add("show");
  }
  var container2 = document.querySelector('.accountDropdown');
  if (!container2.contains(e.target)) {
    document.querySelector('.accountDropdown').classList.remove("active");
    document.querySelector('.hide-dh').classList.remove("show");
    document.querySelector('.show-dh').classList.add("show");
  }
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    //UPDATE ADDON PRODUCTS IN PDP
    const anchorQtys = document.querySelectorAll('.js-anchor-qty')
    if (anchorQtys.length) {
      anchorQtys.forEach(anchorQty => {
        anchorQty.value = this.input.value
      })
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    // this.updateOptionStatus();
    this.filterMedia();
    this.updateOptionValues();
    this.updateVariantInput();
    this.updateMedia();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.updateStickyButton();
    } else {
      this.updateURL();
      this.updateSticky();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptionStatus() {
    const { variantData } = this
    const numberOptions = this.querySelectorAll('fieldset.product-form__input').length
    if (numberOptions === 2){
      const option1 = this.querySelector('fieldset.product-form__input:nth-child(1)').querySelector('input:checked').value
      const option2 = this.querySelector('fieldset.product-form__input:nth-child(2)').querySelector('input:checked').value
      const availableValue1 = variantData.filter(variant => variant.option2 === option2 && variant.inventory_quantity).map(value => value.option1)
      const availableValue2 = variantData.filter(variant => variant.option1 === option1 && variant.inventory_quantity).map(value => value.option2)
      const label1s = this.querySelector('fieldset.product-form__input:nth-child(1)').querySelectorAll('input')
      const label2s = this.querySelector('fieldset.product-form__input:nth-child(2)').querySelectorAll('input')
      for (const label of label1s){
        const isDisabled = !availableValue1.includes(label.value)
        label.classList[`${isDisabled ? 'add' : 'remove'}`]('disabled')
      }
      for (const label of label2s){
        const isDisabled = !availableValue2.includes(label.value)
        label.classList[`${isDisabled ? 'add' : 'remove'}`]('disabled')
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  filterMedia () {
    const productTitle = productObject?.title?.trim();
    if (this.currentVariant && this.currentVariant.featured_media && this.currentVariant.featured_media.alt){
      document.querySelectorAll('[thumbnail-color]').forEach(thumb => {
        console.log(productTitle,"productTitle")
       if (thumb.getAttribute('thumbnail-color') !== productTitle) {
        thumb.classList.add('thumb-hidden');
        thumb.classList.remove('thumb-show');
      }
      })
      const selected_variant = this.currentVariant.featured_media.alt;
      console.log(selected_variant,"MEDIA ALT");
      let selected_attribute = `[thumbnail-color="${selected_variant}"]`;
            console.log(selected_attribute,"selected_attribute");

      if (selected_variant.includes('"')) {
        selected_attribute = `[thumbnail-color='${selected_variant}']`;
      }
      document.querySelectorAll(selected_attribute).forEach(thumb => {
            thumb.classList.remove('thumb-hidden');
            thumb.classList.add('thumb-show');
      })
    }
  }

  updateMasterId() {
    var currentV = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    console.log(currentV, this.options);
    const buyNowBtn = document.getElementById('buy-now-btn');
    if (buyNowBtn) {
     if (currentV.available) {
        buyNowBtn.setAttribute('data-buy-now', currentV.id);
        buyNowBtn.style.display = 'flex';
      } else {
        buyNowBtn.style.display = 'none';
      }
    }
    this.currentVariant = currentV
  }

  updateMedia() {
    let currentMain = this.currentVariant
    if (!currentMain){
       //handle for unavailable combination COLOR AND SIZE
      currentMain =  this.variantData.find((variant) => {
          return  this.options[0] == variant.option1 
        });
        if (currentMain && currentMain.featured_media && currentMain.featured_media.alt){
          document.querySelectorAll('[thumbnail-color]').forEach(thumb => {
            thumb.classList.add('thumb-hidden');
            
          })
          const selected_variant = currentMain.featured_media.alt;
          let selected_attribute = `[thumbnail-color="${selected_variant}"]`;
          if (selected_variant.includes('"')) {
            selected_attribute = `[thumbnail-color='${selected_variant}']`;
          }
          document.querySelectorAll(selected_attribute).forEach(thumb => {
            thumb.classList.remove('thumb-hidden');
             
          })
        }
    }
    console.log(currentMain,'MAIN');
    if (!currentMain.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${currentMain.featured_media.id}"]`
    );
    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${currentMain.featured_media.id}"]`);
    const parent = newMedia.parentElement;

    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);


    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    // window.setTimeout(() => {
    //   parent.scrollLeft = 0;
    //   parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    // });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateOptionValues(){
    const currentVariant =  this.currentVariant
    if (currentVariant){
      const {option1, option2, option3} = currentVariant
      if (option1){
        document.querySelector('.js-option-value-1').innerHTML = option1
      }
      if (option2){
        document.querySelector('.js-option-value-2').innerHTML = option2
      }
      if (option3){
        document.querySelector('.js-option-value-3').innerHTML = option3
      }
    }else{
       //handle for unavailable combination COLOR AND SIZE
      if (this.options[0]){
        document.querySelector('.js-option-value-1').innerHTML = this.options[0]
      }
      if (this.options[1]){
        document.querySelector('.js-option-value-2').innerHTML = this.options[1]
      }
      if (this.options[2]){
        document.querySelector('.js-option-value-2').innerHTML = this.options[2]
      }
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const { currentVariant, variantData } = this
      const inputPoints = document.querySelector('input[name="properties[Points]"]');
      const displayPoint = document.querySelector('#js-cw-point')
      const optionBoxes = [...document.querySelectorAll('.cw-form-options')]
      if(currentVariant == undefined){
        //handle for unavailable combination COLOR AND SIZE
        const avaibableOptionForCurrentColor = [...new Set(variantData?.filter(i => i.option1 === this.options[0] && i.available == true).map(i => i.option2))]
        const avaibableOptionForCurrentSize = [...new Set(variantData?.filter(i => i.option2 === this.options[1] && i.available == true ).map(i => i.option1))]
        optionBoxes[0]?.querySelectorAll('label').forEach(i => {
          i.classList[`${avaibableOptionForCurrentSize.includes(i.getAttribute('title')) ? 'remove' : 'add'}`]('partially-disabled')
        })
        optionBoxes[1]?.querySelectorAll('label').forEach(i => {
          i.classList[`${avaibableOptionForCurrentColor.includes(i.getAttribute('title')) ? 'remove' : 'add'}`]('partially-disabled')
        })
        console.log(avaibableOptionForCurrentColor,avaibableOptionForCurrentSize,'Available for current');
        setTimeout(function(){
          $('.swym-button-bar').hide();
          $('#SI_trigger').hide();
        },500)
      }else{
      const input = productForm.querySelector('input[name="id"]');
      input.value = currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      
      const availableOption1 = [...new Set(variantData?.filter(i => i.option2 === currentVariant.option2 && i.option3 === currentVariant.option3 && i.available == true).map(i => i.option1))]
      const availableOption2 = [...new Set(variantData?.filter(i => i.option1 === currentVariant.option1 && i.option3 === currentVariant.option3 && i.available == true).map(i => i.option2))]
      const availableOption3 = [...new Set(variantData?.filter(i => i.option1 === currentVariant.option1 && i.option2 === currentVariant.option2).map(i => i.option3))]
      console.log(variantData,'Variant Data')
        optionBoxes[0]?.querySelectorAll('label').forEach(i => {
          i.classList[`${availableOption1.includes(i.getAttribute('title')) ? 'remove' : 'add'}`]('partially-disabled')
        })
        optionBoxes[1]?.querySelectorAll('label').forEach(i => {
          i.classList[`${availableOption2.includes(i.getAttribute('title')) ? 'remove' : 'add'}`]('partially-disabled')
        })
        optionBoxes[2]?.querySelectorAll('label').forEach(i => {
          i.classList[`${availableOption3.includes(i.getAttribute('title')) ? 'remove' : 'add'}`]('partially-disabled')
        })
        $('.swym-button-bar').show();
        $('#SI_trigger').show();
        if (inputPoints){
          const dataPoints = JSON.parse(inputPoints.dataset.points)
          if (currentVariant.compare_at_price && currentVariant.compare_at_price !== currentVariant.price) {
            inputPoints.value = 0 
          } else {
            inputPoints.value = dataPoints[currentVariant.id];
          }
          inputPoints.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (displayPoint){
          const dataPoints = JSON.parse(displayPoint.dataset.points)
          if (currentVariant.compare_at_price && currentVariant.compare_at_price !== currentVariant.price) {
            displayPoint.innerHTML = 0;
           
          } else {
            displayPoint.innerHTML = dataPoints[currentVariant.id]
          
          }
        }
      }
     
    });
  }

  updateStickyButton(){
    const stickyCartButton = document.querySelector('.sticky-cart button')
    stickyCartButton && stickyCartButton.setAttribute('disabled', '');
    stickyCartButton && (stickyCartButton.innerHTML = "Unavailable")
  }

  updateSticky(){
    const currentVariant = this.currentVariant
    const stickyPrice =  document.querySelector('.js-sc-price')
    const stickyComparePrice =  document.querySelector('.js-sc-compare-price')
    const comparePrice = currentVariant.compare_at_price ? currentVariant.compare_at_price : 0
    const { available } = currentVariant
    const stickyCartButton = document.querySelector('.sticky-cart button')
    stickyCartButton && stickyCartButton.removeAttribute('disabled');
    stickyCartButton &&  stickyCartButton.classList[`${available ? 'remove': 'add'}`]('stick-card-notify')
    stickyCartButton && (stickyCartButton.innerHTML = available ? 'Add to cart' : 'Notify me')
    if (stickyPrice && currentVariant){
      stickyPrice.innerHTML = Shopify.formatMoney(currentVariant.price)
    }
    if (stickyComparePrice && comparePrice){
      stickyComparePrice.innerHTML = Shopify.formatMoney(comparePrice)
    }else{
      stickyComparePrice.innerHTML = ''
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        // Update point
        const pointsId = `points-${this.dataset.section}`;
        const destinationPoints = document.getElementById(pointsId);
        const sourcePoints = html.getElementById(pointsId);

        if (sourcePoints && destinationPoints) {
            destinationPoints.innerHTML = sourcePoints.innerHTML;
        }
        // Update stock
        const stockId = `stock-${this.dataset.section}`
        const destinationStock = document.getElementById(stockId);
        const sourceStock = html.getElementById(stockId);

        if (sourceStock && destinationStock) destinationStock.innerHTML = sourceStock.innerHTML;

        // Update property for addon products
        const itemName = this.currentVariant.name
        document.querySelectorAll('.js-prop-main-product').forEach(item => {
          item.value = this.currentVariant.name
        })
        
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const invetoryBox = document.querySelector('.count-p-left-text ')
    invetoryBox && invetoryBox.classList.add('hide')
    if (!addButton) return;
    addButtonText.textContent = 'Sold Out';
    if($('.price__badge-sold-out').is(':hidden')){
      $('.price__badge-sold-out').show();
    }
    // if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

const initSwatch = () => {
  const SWATCH_SELECTOR = '.js-swatch-card-item'
  const swatches = document.querySelectorAll(SWATCH_SELECTOR)
  for (const swatch of swatches){
      swatch.addEventListener('mouseover', function(e){
          const self = e.target
          const siblings = self.parentElement.querySelectorAll(SWATCH_SELECTOR)
          const newImage = self.dataset.image
          for (const sibling of siblings) {
              sibling.classList.remove('active')
          }
          self.classList.add('active')
          const gridItem = self.closest('.js-product-card')
          const gridImage = gridItem.querySelector('.product-card__image').querySelector('img')
          newImage && gridImage.setAttribute('srcset',newImage)
      })
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent("change", false, true);
  const variantSelectors = document.querySelector('variant-radios,variant-selects')
  variantSelectors && variantSelectors.dispatchEvent(evt); 
})

// Carousel
const themeCarousel = function(){
  if (document.querySelector(".js-carousel-acc")){
  const accCarousel = new Carousel(document.querySelector(".js-carousel-acc"), {
    infinite: true,
    dots:false,
    dragFree:true,
    center:false,
  })
  }

  if (document.querySelector(".js-carousel-upsell")){
    const upsellCarousel = new Carousel(document.querySelector(".js-carousel-upsell"), {
      infinite: true,
      dots:false,
      dragFree:true,
      center:false,
    })
  }

  if (document.querySelector(".js-carousel-co")){
    const calloutsCarousel = new Carousel(document.querySelector(".js-carousel-co"), {
      infinite: true,
      dots:true,
      arrows:false,
      dragFree:true,
      center:true,
    })
  }
}

themeCarousel()
// window.onload = function() {
//   themeCarousel()
// };

// Swatches
window.onload = function() {
  initSwatch()
}
if(document.querySelector('.link__account') !== null){
document.querySelector('.link__account').setAttribute('href', domains.cms_url + '/user/account')
}